module.exports = require("./ff-Latn-CM.d.ts");